// extracted by mini-css-extract-plugin
export default {"button":"LegalEntity_button__qTxqW"};